import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { Appointment, AuthPayload } from "../engine/models/models";
import { InspirationGallery } from "../models/InspirationGallery";
import { SessionType } from "../enum";
@Injectable({ providedIn: "root" })

export class ClientConfiguratioService {
  constructor(private http: HttpClient) { }


  updateVideoWatched(contractId: number, videoType: number): Observable<any> {
    return this.http.get<any>(`${environment.api}/api/clientConfiguration?contractId=${contractId}&videoType=${videoType}`);
  }
  toggleClientAccess(contractId: number): Observable<any> {
    return this.http.get<any>(`${environment.api}/api/clientConfiguration/clientAccess?contractId=${contractId}`);
  }
  UpdateClientSession(contractId: number, type: SessionType): Observable<void> {
    return this.http.put<void>(`${environment.api}/api/clientConfiguration?contractId=${contractId}&type=${type}`, null);
  }
}
